import React, { Component } from 'react';
import { ScreensCenteredBarCodeReader, BarCodeReader } from '../../components/BarCodeReader';
import ScreensLoading from '../../components/Loading';
import TireSetInfo from '../../components/TireSetInfo';
import { Divider, Grid } from '@material-ui/core';
import Alert from '../../components/Alert';
import api from '../../utils/api';
import { getOfficeId } from '../../utils/preferences';

class TireChangingScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
        tireSetBarCode: undefined,
        shelfBarCode: undefined,
        tireSetInfo: undefined
    };
  }

  post = barCodes => {
    const officeId = getOfficeId();
    this.props.post({ OfficeId: getOfficeId(), ...barCodes })
      .then(res => {
        this.setState({
          alert: { message: res.data },
          tireSetInfo: [{ label: "", value: "Haetaan rengassarjan tietoja..." }]
        });

        // Get tire set info
        api
          .tireSet
          .get(barCodes.RegisterNumber, officeId)
          .then(tres => this.setState({ tireSetInfo: tres.data }))
          .catch(_ => {});
      })
      .catch(({ response: { data } = { data: 'Yhteys palvelimeen ei toimi' } }) => this.setState({
        tireSetInfo: [],
        alert: {
          message: data,
          isError: true,
        },
      }))
      .finally(_ => this.setState({
        tireSetBarCode: undefined,
        shelfBarCode: undefined,
      }));
  }

  handleBarCodeRead = type => barCode => {
    this.setState({ tireSetInfo: undefined, [type]: barCode });
    // If only tire set is read in this screen, post at this point
    if (type === 'tireSetBarCode' && !this.props.isShelfBarCodeReadAfterTireSet)
        this.post({ RegisterNumber: barCode });
    if (type === 'shelfBarCode')
        this.post({ RegisterNumber: this.state.tireSetBarCode, StorageLocationCode: barCode });
  };

  render() {
    const {
      tireSetBarCode,
      shelfBarCode,
      tireSetInfo
    } = this.state;

    if(!tireSetInfo && !tireSetBarCode)
      return <ScreensCenteredBarCodeReader manualInputLabel="tai kirjoita rek.nro" key="tireSetBarCodeReader" onBarCodeRead={this.handleBarCodeRead('tireSetBarCode')}>
          {this.props.readTireSetBarCodeMessage /* Hyllytä rengassarja lukemalla ensin rengassarjan viivakoodi ja tämän jälkeen hyllyn viivakoodi */}
        </ScreensCenteredBarCodeReader>;

    if(!tireSetInfo && !shelfBarCode && this.props.isShelfBarCodeReadAfterTireSet)
      return <ScreensCenteredBarCodeReader manualInputLabel="tai kirjoita hyllytunniste" key="shelfBarCodeReader" onBarCodeRead={this.handleBarCodeRead('shelfBarCode')}>
          {this.props.readShelfBarCodeMessage /*Kuittaa rengassarja hyllytetyksi lukemalla hyllyn viivakoodi*/}
        </ScreensCenteredBarCodeReader>;

    if(!tireSetInfo)
      return <ScreensLoading>
          {this.props.loadingMessage /*Kuitataan rengassarjaa hyllytetyksi*/}
        </ScreensLoading>;

      return (
          <Grid>
          <Grid item>
            <TireSetInfo {...{ tireSetInfo }}>
              <Divider />
              <BarCodeReader onBarCodeRead={this.handleBarCodeRead('tireSetBarCode')} manualInputLabel="Kirjoita seuraava rek.nro" />
              <Alert title={this.state.alert.message} isError={this.state.alert.isError}>
                Voit lukea seuraavan rengassarjan viivakoodin
              </Alert>
            </TireSetInfo>
          </Grid>
        </Grid>
      );
  }
}

export const KeraileJaLaheta = () => (
  <TireChangingScreen
    post={api.tireSet.post('pickUpAndSend')}
    readTireSetBarCodeMessage="Keräile ja lähetä rengassarja lukemalla sen viivakoodi"
    loadingMessage="Kuitataan rengassarjaa keräillyksi ja lähetetyksi"
    />
);

export const VastaanotaKorjaamolla = () => (
  <TireChangingScreen
    post={api.tireSet.post('receiveInWorkshop')}
    readTireSetBarCodeMessage="Kuittaa rengassarja vastaanotetuksi korjaamolle lukemalla sen viivakoodi"
    loadingMessage="Kuitataan rengassarjaa vastaanotetuksi"
    />
);

export const VaihdaJaLahetaVarastolle = () => (
  <TireChangingScreen
    post={api.tireSet.post('changeAndSendToWarehouse')}
    readTireSetBarCodeMessage="Kuittaa renkaat vaihdetuksi ja lähetetyksi lukemalla rengassarjan viivakoodi"
    loadingMessage="Kuitataan rengassarjaa vaihdetuksi ja lähetetyksi"
    />
);

export const VastaanotaVarastolla = () => (
  <TireChangingScreen
    post={api.tireSet.post('receiveInWarehouse')}
    readTireSetBarCodeMessage="Kuittaa rengassarja vastaanotetuksi varastolle lukemalla sen viivakoodi"
    loadingMessage="Kuitataan rengassarjaa vastaanotetuksi"
    />
);

export const Hyllyta = () => (
  <TireChangingScreen
    post={api.tireSet.post('storeInWarehouse')}
    isShelfBarCodeReadAfterTireSet={true}
    readTireSetBarCodeMessage="Hyllytä rengassarja lukemalla ensin rengassarjan viivakoodi ja tämän jälkeen hyllyn viivakoodi"
    readShelfBarCodeMessage="Kuittaa rengassarja hyllytetyksi lukemalla hyllyn viivakoodi"
    loadingMessage="Kuitataan rengassarjaa hyllytetyksi"
  />
);

export default TireChangingScreen;